import { ActionTypes } from 'utils/constants';
import { getDeepProp } from 'utils/get-deep-prop';

const initialState = { videosProcessing: new Set() };

const completeVideosFromCourse = course => {
    const contents = course.contents || [];
    return contents.reduce((a, chapter) => {
        chapter.videos.forEach(video => {
            if (video.complete) {
                a.add(video.id);
            }
        });

        return a;
    }, new Set());
};

export const completeVideos = (state = initialState, action) => {
    switch(action.type) {
        case ActionTypes.FETCH_COURSE + '_FULFILLED': {
            const course = getDeepProp(action, 'payload', 'data', 'course') || {};
            const ids = completeVideosFromCourse(course);

            return {
                ...state,
                ids
            };
        }
        case ActionTypes.COPY_MODAL_COURSE: {
            const ids = completeVideosFromCourse(action.payload);

            return {
                ...initialState,
                ids
            };
        }
        case ActionTypes.TOGGLE_VIDEO_COMPLETE: {
            const videosProcessing = new Set(state.videosProcessing);
            videosProcessing.add(action.payload.videoId);

            return {
                ...state,
                videosProcessing
            };
        }
        case ActionTypes.TOGGLE_VIDEO_COMPLETE + '_FULFILLED': {
            const videosProcessing = new Set(state.videosProcessing);
            const videoIdComplete = getDeepProp(action, 'payload', 'data', 'video_id')
            videosProcessing.delete(videoIdComplete);
            
            const complete = getDeepProp(action, 'payload', 'data', 'complete')
            const ids = new Set(state.ids);

            if (complete) {
                ids.add(videoIdComplete);
            } else {
                ids.delete(videoIdComplete);
            }
            
            return {
                ...state,
                ids,
                videosProcessing
            };
        }
        case ActionTypes.SET_VIDEO_POSITION + '_FULFILLED': {
            const complete = getDeepProp(action, 'payload', 'data', 'complete')
            const videoIdComplete = getDeepProp(action, 'payload', 'data', 'video_id')            
            const ids = new Set(state.ids);

            if (complete) {
                ids.add(videoIdComplete);
            }
            
            return {
                ...state,
                ids
            };
        }
        default: {
            return state;
        }
    }
};
